// Circular progress drawn as SVG: `pct` (0–100) fills the arc from the top, children sit in the middle.
// The ring is decorative; `label` is the spoken version of what it shows.
export default function Ring({ pct, size, stroke, colorClass, trackClass = 'stroke-base-300', label, className = '', children }) {
  const r = 50 - stroke / 2;
  const circumference = 2 * Math.PI * r;
  return (
    <div role="img" aria-label={label} className={`relative shrink-0 ${className}`} style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" className={`size-full -rotate-90 ${colorClass}`} aria-hidden="true">
        <circle cx="50" cy="50" r={r} fill="none" strokeWidth={stroke} className={trackClass} />
        {pct > 0 && (
          <circle cx="50" cy="50" r={r} fill="none" strokeWidth={stroke} stroke="currentColor" strokeLinecap="round"
            className="ring-arc" strokeDasharray={circumference}
            strokeDashoffset={circumference * (1 - Math.min(100, pct) / 100)} />
        )}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center" aria-hidden="true">{children}</div>
    </div>
  );
}
